import Vue from 'vue';
import {
    FETCH_EMPLOYEES,
    FETCH_ARCHIVED_EMPLOYEES,
    FETCH_EMPLOYEES_BY_ROLE,
    EDIT_EMPLOYEE_EMAIL,
    EDIT_EMPLOYEE_PASSWORD,
    EDIT_EMPLOYEE_FIRSTNAME,
    EDIT_EMPLOYEE_LASTNAME,
    EDIT_EMPLOYEE_COORDINATOR,
    EDIT_EMPLOYEE_TRACK_JIRA,
    EDIT_EMPLOYEE_VACATION_DAYS,
    CLEAR_EMPLOYEE_COORDINATOR,
    EDIT_EMPLOYEE_EDIT_PHONE,
    EDIT_EMPLOYEE_EDIT_POSITION,
    EDIT_EMPLOYEE_ADD_PHONE,
    EDIT_EMPLOYEE_ADD_POSITION,
    EDIT_EMPLOYEE_ADD_FACILITY,
    EDIT_EMPLOYEE_ADD_BENEFIT,
    EDIT_EMPLOYEE_REMOVE_PHONE,
    EDIT_EMPLOYEE_REMOVE_FACILITY,
    EDIT_EMPLOYEE_REMOVE_POSITION,
    EDIT_EMPLOYEE_REMOVE_BENEFIT,
    EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE,
    EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE,
    EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE,
    EDIT_EMPLOYEE_BENEFIT_CHANGE,
    EDIT_EMPLOYEE_SKYPE,
    EDIT_EMPLOYEE_TELEGRAM,
    EDIT_EMPLOYEE_ROCKETCHAT,
    EDIT_EMPLOYEE_CONTACT_EMAIL,
    EDIT_EMPLOYEE_ENGLISH,
    EDIT_EMPLOYEE_PHOTOURL,
    SET_UPLOADING_PHOTO,
    VIEW_EMPLOYEE,
    DELETE_EMPLOYEE,
    ARCHIVE_EMPLOYEE,
    DUPLICATE_EMPLOYEE,
    ADD_NEW_EMPLOYEE,
    EDIT_EMPLOYEE,
    SEARCH_EMPLOYEE,

    FETCH_ROLES,
    EDIT_ROLE,
    DELETE_ROLE,
    TOGGLE_ROLE,
    TOGGLE_ADMIN_ROLE,
    MAP_ROLES,
    ADD_ROLE,
    SAVE_ROLE,
    CANCEL_EDIT_ROLE,

    FETCH_DEPARTMENTS,
    SAVE_DEPARTMENT,
    DELETE_DEPARTMENT,
    EDIT_DEPARTMENT,
    ADD_DEPARTMENT,
    CANCEL_EDIT_DEPARTMENT,
    TOGGLE_DEPARTMENT,
    MAP_DEPARTMENTS,

    UPDATE_SALARY,
    EDIT_SALARY,
    UPDATE_SALARY_AMOUNT,
    UPDATE_SALARY_CHANGE_REASON,
    UPDATE_SALARY_CURRENCY,
    UPDATE_SALARY_DATE,
    DELETE_SALARY,
    ADD_SALARY,

    FETCH_CURRENCIES,
    ADD_CURRENCY,
    DELETE_CURRENCY,
    SAVE_CURRENCY,
    EDIT_CURRENCY,
    CANCEL_EDIT_CURRENCY,

    FETCH_FACILITY_TYPES,
    ADD_FACILITY_TYPE,
    DELETE_FACILITY_TYPE,
    SAVE_FACILITY_TYPE,
    EDIT_FACILITY_TYPE,
    CANCEL_EDIT_FACILITY_TYPE,

    FETCH_FACILITY_DEVICES,
    ADD_FACILITY_DEVICE,
    DELETE_FACILITY_DEVICE,
    SAVE_FACILITY_DEVICE,
    EDIT_FACILITY_DEVICE,
    CANCEL_EDIT_FACILITY_DEVICE,

    FETCH_BENEFITS,
    ADD_BENEFIT,
    DELETE_BENEFIT,
    SAVE_BENEFIT,
    EDIT_BENEFIT,
    CANCEL_EDIT_BENEFIT,

    CHECK_GOOGLE_ACCOUNT,
    EDIT_GOOGLE_ACCOUNT_CREATION
} from './mutation-types';
import AuthService from '@/services/AuthService';

export function fetchEmployees({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/users`).then(res => {
            commit(FETCH_EMPLOYEES, res.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function fetchArchivedEmployees({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/users/archived`).then(res => {
            commit(FETCH_ARCHIVED_EMPLOYEES, res.body);
            resolve();
        })
        .catch(error => {
            reject(error);
        });
    });
}

export function fetchEmpoyeesByRole({ commit }, role) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/users/role/${role}`)
            .then(result => {
                commit(FETCH_EMPLOYEES_BY_ROLE, {
                    role: role,
                    employees: result.body
                });
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function isGoogleAccountExist({ commit }, email) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/users/check-google-account?email=${email}`)
            .then(result => {
                commit(CHECK_GOOGLE_ACCOUNT, result.body);
                resolve(result.body);
            }).catch(error => {
                reject(error);
            });
    });
}

// edit employee actions

export function editEmployeeEmail({ commit }, email) {
    commit(EDIT_EMPLOYEE_EMAIL, email);
}

export function editEmployeePassword({ commit }, password) {
    commit(EDIT_EMPLOYEE_PASSWORD, password);
}

export function editEmployeeFirstname({ commit }, firstname) {
    commit(EDIT_EMPLOYEE_FIRSTNAME, firstname);
}

export function editEmployeeLastname({ commit }, lastname) {
    commit(EDIT_EMPLOYEE_LASTNAME, lastname);
}

export function editEmployeeCoordinator({ commit }, coordinator) {
    commit(EDIT_EMPLOYEE_COORDINATOR, coordinator);
}

export function editEmployeeTrackJira({ commit }, trackJira) {
    commit(EDIT_EMPLOYEE_TRACK_JIRA, trackJira);
}

export function editGoogleAccountCreation({ commit }, createGoogleAccount) {
    commit(EDIT_GOOGLE_ACCOUNT_CREATION, createGoogleAccount);
}

export function editEmployeeVacationDays({ commit }, vacationDays) {
    commit(EDIT_EMPLOYEE_VACATION_DAYS, vacationDays);
}

export function clearEmployeeCoordinator({ commit }) {
    commit(CLEAR_EMPLOYEE_COORDINATOR);
}

export function editEmployeePhoneNumber({ commit }, phonenumber) {
    commit(EDIT_EMPLOYEE_EDIT_PHONE, phonenumber);
}

export function addEmployeePhoneNumber({ commit }) {
    commit(EDIT_EMPLOYEE_ADD_PHONE);
}

export function addEmployeeFacility({ commit }) {
    commit(EDIT_EMPLOYEE_ADD_FACILITY);
}

export function addEmployeeBenefit({ commit }) {
    commit(EDIT_EMPLOYEE_ADD_BENEFIT);
}

export function removeEmployeeFacility({ commit }, facilityIndex) {
    commit(EDIT_EMPLOYEE_REMOVE_FACILITY, facilityIndex);
}

export function removeEmployeeBenefit({ commit }, benefitIndex) {
    commit(EDIT_EMPLOYEE_REMOVE_BENEFIT, benefitIndex);
}

export function changeEmployeeFacilityDevice({ commit }, facilityDevice) {
    commit(EDIT_EMPLOYEE_FACILITY_DEVICE_CHANGE, facilityDevice);
}

export function changeEmployeeFacilityType({ commit }, facilityType) {
    commit(EDIT_EMPLOYEE_FACILITY_TYPE_CHANGE, facilityType);
}

export function changeEmployeeFacilityNumber({ commit }, facilityNumber) {
    commit(EDIT_EMPLOYEE_FACILITY_NUMBER_CHANGE, facilityNumber);
}

export function changeEmployeeBenefit({ commit }, benefit) {
    commit(EDIT_EMPLOYEE_BENEFIT_CHANGE, benefit);
}

export function removeEmployeePhoneNumber({ commit }, phoneIndex) {
    commit(EDIT_EMPLOYEE_REMOVE_PHONE, phoneIndex);
}

export function editEmployeeSkype({ commit }, skype) {
    commit(EDIT_EMPLOYEE_SKYPE, skype);
}

export function editEmployeeTelegram({ commit }, telegram) {
    commit(EDIT_EMPLOYEE_TELEGRAM, telegram);
}

export function editEmployeeRocketChat({ commit }, rocketChat) {
    commit(EDIT_EMPLOYEE_ROCKETCHAT, rocketChat);
}

export function editEmployeeContactEmail({ commit }, contactEmail) {
    commit(EDIT_EMPLOYEE_CONTACT_EMAIL, contactEmail);
}

export function editEmployeeEnglish({ commit }, englishLevel) {
    commit(EDIT_EMPLOYEE_ENGLISH, englishLevel);
}

export function editEmployeePosition({ commit }, position) {
    commit(EDIT_EMPLOYEE_EDIT_POSITION, position);
}

export function addEmployeePosition({ commit }) {
    commit(EDIT_EMPLOYEE_ADD_POSITION);
}

export function removeEmployeePosition({ commit }, positionIndex) {
    commit(EDIT_EMPLOYEE_REMOVE_POSITION, positionIndex);
}

export function editEmployeePhotoUrl({ commit }, photoUrl) {
    commit(EDIT_EMPLOYEE_PHOTOURL, photoUrl);
}

export function setUploadingPhoto({ commit }, photo) {
    commit(SET_UPLOADING_PHOTO, photo);
}

export function uploadPhoto({ commit }, photo) {
    let form = new FormData();
    form.append('photo', photo);
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/users/upload`, form
        ).then(res => {
            resolve(res);
        }).catch(error => {
            reject(error);
        });
    });
};

export function addNewEmployee({ commit }, newEmployee) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/users/create`, newEmployee
        ).then((response) => {
            (commit(ADD_NEW_EMPLOYEE, newEmployee));
            resolve(response.body.isGoogleOperationCompleted);
        }).catch(error => {
            reject(error);
        });
    });
};

export const fetchEmployee = ({ commit }, userId) => {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/users/${userId}`
        ).then(res => {
            (commit(VIEW_EMPLOYEE, res.body));
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function viewEmployee({ commit }, employee) {
    commit(VIEW_EMPLOYEE, employee);
};

export function deleteEmployee({ commit }, userId) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/users/delete/${userId}`).then(response => {
            commit(DELETE_EMPLOYEE, userId);
            resolve(response.body.isGoogleOperationCompleted);
        }).catch(error => {
            reject(error);
        });
    });
};

export function archiveEmployee({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/users/archive/${payload.id}`, payload).then(response => {
            commit(ARCHIVE_EMPLOYEE, payload.id);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function duplicateEmployee({ commit }, userId) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/users/duplicate/${userId}`).then(response => {
            commit(DUPLICATE_EMPLOYEE, userId);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
};

export function editEmployee({ commit, state }, payload) {
    payload.updateGoogleAccount = state.employee.firstname !== state.originalEmployee.firstname ||
        state.employee.lastname !== state.originalEmployee.lastname ||
        state.employee.photoUrl !== state.originalEmployee.photoUrl;

    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/users/edit/${payload.userId}`, payload
        ).then(response => {
            commit(EDIT_EMPLOYEE, payload);
            if (payload.userId === this.state.user.user.UserId) {
                let authService = new AuthService(this);
                authService.refresh();
            }
            resolve(response.body.isGoogleOperationCompleted);
        }).catch(error => {
            reject(error);
        });
    });
};

export function changeSearchText({ commit }, searchText) {
    commit(SEARCH_EMPLOYEE, searchText);
}

// roles

export function fetchRoles({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/roles`)
            .then(res => {
                commit(FETCH_ROLES, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteRole({ commit }, id) {
    Vue.http.delete(`${process.env.API}/api/roles/delete/${id}`)
        .then(res => {
            commit(DELETE_ROLE, res.body.id);
        }).catch(() => {});
}

export function changeRole({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/roles/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_ROLE, res.body);
                resolve();
            }).catch(error => {
                commit(CANCEL_EDIT_ROLE);
                reject(error);
                fetchRoles({ commit });
            });
    });
}

export function createNewRole({ commit }, newRole) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/roles/create`, {
            name: newRole
        })
        .then(res => {
            commit(SAVE_ROLE, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function saveRole({ commit }, newRole) {
    if (newRole.id > 0) {
        changeRole({ commit }, newRole);
    } else {
        createNewRole({ commit }, newRole.name);
    }
}

export function addRole({ commit }, role) {
    commit(ADD_ROLE, role);
}
export function editRole({ commit }, roleId) {
    commit(EDIT_ROLE, roleId);
}

export function cancelEditRole({ commit }) {
    commit(CANCEL_EDIT_ROLE);
}

export function toggleRole({ commit }, index) {
    commit(TOGGLE_ROLE, index);
}

export function toggleAdminRole({ commit }, index) {
    commit(TOGGLE_ADMIN_ROLE, index);
}

export function mapRoles({ commit }, roles) {
    commit(MAP_ROLES, roles);
}
// departments

export function fetchDepartments({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/departments`)
            .then(res => {
                commit(FETCH_DEPARTMENTS, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteDepartment({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/departments/delete/${id}`)
            .then(res => {
                commit(DELETE_DEPARTMENT, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeDepartment({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/departments/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_DEPARTMENT, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewDepartment({ commit }, newDepartment) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/departments/create`, {
            name: newDepartment
        })
        .then(res => {
            commit(SAVE_DEPARTMENT, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function saveDepartment({ commit }, newDepartment) {
    if (newDepartment.id > 0) {
        changeDepartment({ commit }, newDepartment);
    } else {
        createNewDepartment({ commit }, newDepartment.name);
    }
}

export function addDepartment({ commit }, department) {
    commit(ADD_DEPARTMENT, department);
}

export function editDepartment({ commit }, depId) {
    commit(EDIT_DEPARTMENT, depId);
}

export function cancelEditDepartment({ commit }) {
    commit(CANCEL_EDIT_DEPARTMENT);
}

export function toggleDepartment({ commit }, index) {
    commit(TOGGLE_DEPARTMENT, index);
}

export function mapDepartments({ commit }, departments) {
    commit(MAP_DEPARTMENTS, departments);
}

// salary

export function updateSalary({ commit }, salary) {
    commit(UPDATE_SALARY, salary);
}

export function editSalary({ commit }, payload) {
    commit(EDIT_SALARY, payload);
}

export function updateSalaryAmount({ commit }, amount) {
    commit(UPDATE_SALARY_AMOUNT, amount);
}

export function updateSalaryChangeReason({ commit }, reason) {
    commit(UPDATE_SALARY_CHANGE_REASON, reason);
}

export function updateSalaryCurrency({ commit }, currency) {
    commit(UPDATE_SALARY_CURRENCY, currency);
}

export function updateSalaryDate({ commit }, date) {
    commit(UPDATE_SALARY_DATE, date);
}

export function deleteSalary({ commit }, item) {
    commit(DELETE_SALARY, item);
}

export function addSalary({ commit }, newSalary) {
    commit(ADD_SALARY, newSalary);
}

// currencies

export function fetchCurrencies({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/currencies`)
            .then(res => {
                commit(FETCH_CURRENCIES, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteCurrency({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/currencies/delete/${id}`)
            .then(res => {
                commit(DELETE_CURRENCY, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeCurrency({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/currencies/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_CURRENCY, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewCurrency({ commit }, newCurrency) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/currencies/create`, {
            name: newCurrency
        })
        .then(res => {
            commit(SAVE_CURRENCY, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function addCurrency({ commit }, currency) {
    commit(ADD_CURRENCY, currency);
}

export function editCurrency({ commit }, currencyId) {
    commit(EDIT_CURRENCY, currencyId);
}

export function cancelCurrencyEdit({ commit }) {
    commit(CANCEL_EDIT_CURRENCY);
}

// facility types

export function fetchFacilityTypes({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/facilityTypes`)
            .then(res => {
                commit(FETCH_FACILITY_TYPES, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteFacilityType({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/facilityTypes/delete/${id}`)
            .then(res => {
                commit(DELETE_FACILITY_TYPE, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeFacilityType({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/facilityTypes/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_FACILITY_TYPE, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewFacilityType({ commit }, newFacilityType) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/facilityTypes/create`, {
            name: newFacilityType
        })
        .then(res => {
            commit(SAVE_FACILITY_TYPE, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function addFacilityType({ commit }, facilityType) {
    commit(ADD_FACILITY_TYPE, facilityType);
}

export function editFacilityType({ commit }, facilityTypeId) {
    commit(EDIT_FACILITY_TYPE, facilityTypeId);
}

export function cancelFacilityTypeEdit({ commit }) {
    commit(CANCEL_EDIT_FACILITY_TYPE);
}

// facility devices

export function fetchFacilityDevices({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/facilityDevices`)
            .then(res => {
                commit(FETCH_FACILITY_DEVICES, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteFacilityDevice({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/facilityDevices/delete/${id}`)
            .then(res => {
                commit(DELETE_FACILITY_DEVICE, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeFacilityDevice({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/facilityDevices/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_FACILITY_DEVICE, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewFacilityDevice({ commit }, newFacilityDevice) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/facilityDevices/create`, {
            name: newFacilityDevice
        })
        .then(res => {
            commit(SAVE_FACILITY_DEVICE, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function addFacilityDevice({ commit }, facilityDevice) {
    commit(ADD_FACILITY_DEVICE, facilityDevice);
}

export function editFacilityDevice({ commit }, facilityDeviceId) {
    commit(EDIT_FACILITY_DEVICE, facilityDeviceId);
}

export function cancelFacilityDeviceEdit({ commit }) {
    commit(CANCEL_EDIT_FACILITY_DEVICE);
}

// benefits

export function fetchBenefits({ commit }) {
    return new Promise((resolve, reject) => {
        Vue.http.get(`${process.env.API}/api/benefits`)
            .then(res => {
                commit(FETCH_BENEFITS, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function deleteBenefit({ commit }, id) {
    return new Promise((resolve, reject) => {
        Vue.http.delete(`${process.env.API}/api/benefits/delete/${id}`)
            .then(res => {
                commit(DELETE_BENEFIT, res.body.id);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function changeBenefit({ commit }, payload) {
    return new Promise((resolve, reject) => {
        Vue.http.put(`${process.env.API}/api/benefits/edit/${payload.id}`, payload)
            .then(res => {
                commit(SAVE_BENEFIT, res.body);
                resolve();
            }).catch(error => {
                reject(error);
            });
    });
}

export function createNewBenefit({ commit }, newBenefit) {
    return new Promise((resolve, reject) => {
        Vue.http.post(`${process.env.API}/api/benefits/create`, {
            name: newBenefit
        })
        .then(res => {
            commit(SAVE_BENEFIT, res.body);
            resolve();
        }).catch(error => {
            reject(error);
        });
    });
}

export function addBenefit({ commit }, benefit) {
    commit(ADD_BENEFIT, benefit);
}

export function editBenefit({ commit }, benefitId) {
    commit(EDIT_BENEFIT, benefitId);
}

export function cancelBenefitEdit({ commit }) {
    commit(CANCEL_EDIT_BENEFIT);
}



// WEBPACK FOOTER //
// ./src/store/modules/employees/actions.js